module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAQMAAABtzGvEAAAABlBMVEUAAABmZmZ+SwYRAAAAAXRSTlMAQObYZgAAABlJREFUGNNjoCNgbCCLYvz/vwFKkWsK/QAAjYMND9nHpnQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/shop_add.png
// module id = 53
// module chunks = 39